import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
export function PortalSection({ title, hint, action, children, gap = 3, }) {
    return (_jsxs(Box, { component: "section", sx: { mb: gap }, children: [_jsxs(Stack, { direction: "row", spacing: 1, sx: {
                    alignItems: "baseline",
                    justifyContent: "space-between",
                    mb: hint ? 0.25 : 1.5,
                }, children: [_jsx(Typography, { component: "h3", sx: {
                            fontSize: 11,
                            fontWeight: 700,
                            letterSpacing: "0.08em",
                            textTransform: "uppercase",
                            color: "text.secondary",
                        }, children: title }), action ? _jsx(Box, { sx: { flexShrink: 0 }, children: action }) : null] }), hint ? (_jsx(Typography, { variant: "caption", sx: { color: "text.secondary", display: "block", mb: 1.5 }, children: hint })) : null, children] }));
}
